import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { string } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'

import BrandsByAlphabet from './BrandsByAlphabet/BrandsByAlphabet'

import s from './Brands.scss'


const groupByAlphabet = (brands, gender) =>
  brands
    .map((brand) => {
      const normalizedName = string.trimChars(brand.name, '(|)')
      const letter = normalizedName.charAt(0).toUpperCase()

      return { letter, ...brand }
    })
    .map(({ letter, name }) => {
      const brand = name.replace(/\s/g, '-').toLowerCase()
      const tail  = gender === 'female' ? '-perfumes' : '-colognes'
      const link  = `/${brand}${tail}`

      return {
        name,
        letter,
        link,
      }
    })
    .sort((a, b) => {
      if (a.letter === b.letter) {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      }

      return a.letter < b.letter ? -1 : a.letter > b.letter ? 1 : 0
    })
    .reduce((groups, brand) => {
      const { letter, ...link } = brand
      const groupIndex = groups.findIndex(([matchingLetter]) => matchingLetter === letter)

      if (groupIndex > -1) {
        groups[groupIndex][1].push(link)
        return groups
      }

      return [ ...groups, [ letter, [ link ] ] ]
    }, [])

const BrandsPage = (props) => {
  const { meta, title, description, brands } = props

  const femaleBrands  = groupByAlphabet(brands.female, 'female')
  const maleBrands    = groupByAlphabet(brands.male, 'male')

  return (
    <div>
      <Helmet
        title={meta.title}
        meta={[
          { name: 'description', content: meta.description },
        ]}
      />
      <Box className={s.title} mb="36">{title}</Box>
      <div className={s.section}>
        <Box className={s.sectionTitle} mb="24">Perfumes</Box>
        <BrandsByAlphabet items={femaleBrands} />
      </div>
      <Box className={s.section} mt="36" mb="36">
        <Box className={s.sectionTitle} mb="24">Colognes</Box>
        <BrandsByAlphabet items={maleBrands} />
      </Box>
      <Box pt="36" className={s.descriptionWrapper}>
        <div className={s.description} dangerouslySetInnerHTML={{ __html: description }} />
      </Box>
    </div>
  )
}

BrandsPage.propTypes = {
  meta: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  title: PropTypes.string,
  description: PropTypes.string,
  brands: PropTypes.shape({
    female: PropTypes.array,
    male: PropTypes.array,
  }),
}

export default BrandsPage
